import { PostCreateState } from "@/mk2/apps/forum/containers/PostCreate/PostCreate.reducers";
import { AppState } from "@/mk2/reducers";

export const getForumPostCreateState = (state: AppState): PostCreateState =>
    state.containers.forum.forumPostCreate;
